const APPS_API_BASE = process.env.REACT_APP_API_URL_2;
const PLATFORM_API_BASE = process.env.REACT_APP_API_URL;

const joinUrl = (base, path) =>
  `${String(base || "").replace(/\/?$/, "/")}${String(path || "").replace(/^\//, "")}`;

const withQuery = (url, params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      search.set(key, value);
    }
  });
  const query = search.toString();
  return query ? `${url}?${query}` : url;
};

export const endpoints = {
  apps: {
    projectInfo: (projectId) =>
      joinUrl(APPS_API_BASE, `api/projects/${projectId}/project_info`),

    sensorPlacementByZone: (projectId, zone) =>
      withQuery(joinUrl(APPS_API_BASE, "api/sensor_placement"), {
        project_id: projectId,
        zone,
      }),

    sensorPlacementByScenario: (projectId, scenario) =>
      withQuery(joinUrl(APPS_API_BASE, "api/sensor_placement"), {
        project_id: projectId,
        scenario,
      }),

    shadingProgression: (projectId) =>
      withQuery(joinUrl(APPS_API_BASE, "api/shading_progression"), {
        project_id: projectId,
      }),

    dynamicWindProtection: (projectId, scenario) =>
      withQuery(
        joinUrl(APPS_API_BASE, "api/shading-control/dynamic-wind-protection"),
        {
          project_id: projectId,
          scenario,
        },
      ),

    windRisk: (projectId) =>
      joinUrl(APPS_API_BASE, `api/projects/${projectId}/wind-risk`),
  },

  platform: {
    projectDetails: (projectId) =>
      joinUrl(
        PLATFORM_API_BASE,
        `api/projects/${projectId}/get_project_details/`,
      ),
  },
};
